import { parseResponseError } from 'common/helpers';
import { DatasourceReturnType, ResponseError } from 'models';

import { getForManage, save } from '../datasources/companyPrivacyConfig.datasource';
import {
    CompanyPrivacyConfig,
    SaveCompanyPrivacyConfigRequest,
    SaveCompanyPrivacyConfigResponse
} from '../schemas';

export async function getCompanyPrivacyConfigForManage(
    sid: string
): Promise<DatasourceReturnType<ResponseError, CompanyPrivacyConfig | undefined>> {
    try {
        const data = (await getForManage(sid)).data;

        return [null!, data.result_list?.[0]];
    } catch (error) {
        const reason = parseResponseError(error);

        if (reason) {
            return [reason, null!];
        }

        throw error;
    }
}

export async function saveCompanyPrivacyConfig(
    body: SaveCompanyPrivacyConfigRequest
): Promise<DatasourceReturnType<ResponseError, SaveCompanyPrivacyConfigResponse>> {
    try {
        const data = (await save(body)).data;

        return [null!, data];
    } catch (error) {
        const reason = parseResponseError(error);

        if (reason) {
            return [reason, null!];
        }

        throw error;
    }
}
